import React from 'react';
import { useWeather } from '../../context';
import {
  ModelSelector,
  ModeSelector,
  ParameterSelector,
  FilterControls,
  DateRangeSelector,
  ActionButtons,
  ResolutionSelector,
  TriggerControls,
  CatastrophesPanel,
  StateSelector
} from '../controls';

export function Sidebar() {
  const { modelSelect, parameterSelect } = useWeather();
  const showTriggerControls = modelSelect === 'openmeteo' || 
    (modelSelect === 'xweather' && parameterSelect === 'storm_reports');

  // Don't show controls for shipping view
  if (modelSelect === 'shipping') {
    return (
      <div className="w-80 glass-panel m-4 p-6 overflow-y-auto">
        <h2 className="text-lg font-semibold mb-4">Shipping Routes</h2>
        <p className="text-sm text-[var(--secondary-text)] mb-6">
          Monitoring tropical cyclones along major shipping routes
        </p>
        <ActionButtons />
        <div className="mt-6 pt-6 border-t border-[var(--border-color)]">
          <CatastrophesPanel />
        </div>
      </div>
    );
  }

  return (
    <div className="w-80 glass-panel m-4 p-6 overflow-y-auto">
      <ModelSelector />
      <StateSelector />
      <ModeSelector />
      <ParameterSelector />
      <ResolutionSelector />
      {showTriggerControls && <TriggerControls />}
      <FilterControls />
      <DateRangeSelector />
      <ActionButtons />
      <div className="mt-6 pt-6 border-t border-[var(--border-color)]">
        <CatastrophesPanel />
      </div>
    </div>
  );
}